import { AttackPattern, PatternState } from '../AttackPattern.js';
import { ARENA } from '../../../../config/constants.js';

/**
 * Prism Minefield marks several arena locations, then detonates each marker
 * into a rotating burst. It creates a movement puzzle instead of another
 * boss-centered ring and gives the player a clear, color-coded escape route.
 */
export class PrismMinefield extends AttackPattern {
  constructor({ minPhase = 1, config }) {
    super({ name: 'Prism Minefield', telegraphDuration: 1.25, activeDuration: 0.35, minPhase });
    this.config = config;
  }

  onBegin() {
    const { count, radius } = this.config;
    this._mines = Array.from({ length: count }, (_, i) => {
      const angle = (i / count) * Math.PI * 2 + Math.random() * 0.5;
      const distance = 70 + Math.random() * 90;
      return {
        x: ARENA.x + ARENA.width / 2 + Math.cos(angle) * distance,
        y: ARENA.y + ARENA.height / 2 + Math.sin(angle) * distance,
        radius,
      };
    });
  }

  onActiveStart(_boss, _player, pool) {
    const { bulletCount, damage, speed } = this.config;
    for (const mine of this._mines) {
      for (let i = 0; i < bulletCount; i++) {
        const angle = (i / bulletCount) * Math.PI * 2;
        pool.fire({
          x: mine.x,
          y: mine.y,
          vx: Math.cos(angle) * speed,
          vy: Math.sin(angle) * speed,
          radius: 2.5,
          damage,
          color: '#c084fc',
          lifetime: 2.5,
        });
      }
    }
  }

  getVisual() {
    if (this.state !== PatternState.TELEGRAPH && this.state !== PatternState.ACTIVE) return null;
    return {
      kind: 'prismMines',
      mines: this._mines,
      imminent: this.state === PatternState.ACTIVE,
    };
  }
}
